export const SEARCH_PAGE = 'pagina-resultado-busca';
export const SEARCH_BAR = 'sugestao-pesquisa';

export const generateItemListName = (isSearchPage: boolean, isSearchBar: boolean, payload: any) => {
  if (isSearchPage) {
    return SEARCH_PAGE;
  }

  if (isSearchBar) {
    return SEARCH_BAR;
  }

  if (payload?.data?.length) {
    return payload?.data[0].itemListName || payload?.data[0].departmentName;
  }

  return '';
};
